import { useRef, useEffect, DependencyList } from 'react';

export function usePrevious<T>(state: T, deps: DependencyList): T | null{
  const ref = useRef<T>(null);

  useEffect(() => {
    ref.current = state;
  }, deps);

  return ref.current;
}
